import {Component} from '@angular/core';

import {AppAlertService, SubtitlesService} from "../../../core";

@Component({
    selector: 'regulations-de',
    templateUrl: './regulations-de.component.html',
    styleUrls: ['./regulations-de.component.scss']
})
export class RegulationsDeComponent {
    constructor(
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
    }
}
